import { Alert, Button, Grid } from '@mui/material';
import { useGetIndividualContractorQuery } from '../../../../app/Slices/SevenDayApiSlice';
import UserRole from '../../../../shared/AuthRoles';
import React, { useEffect } from 'react';
import { NavigateNext } from '@mui/icons-material';
import { useNavigate } from 'react-router';

const ContractorStats = () => {
    const loggedInUser = UserRole();
    const navigate = useNavigate();

    const { data: contractor } = useGetIndividualContractorQuery(
        loggedInUser.company,
        { skip: !loggedInUser?.company },
    );

    return <></>;
};

export default ContractorStats;
